import { BasicButton } from "@goodgamestudios/asset-globals";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;
import {Poker2LayoutManager} from "../Poker2LayoutManager";

export class Poker2HelpDialog extends Poker2Dialog {
    public static NAME: string = "Poker2HelpDialog";
    private static MAX_TABS_HELP: number = 3;
    private selectedButton: BasicButton;
    private currentPage: number = 0;
    private multiPage: boolean = false;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        super.init();
        this.setButtonText();
    }
    public show(): void {
        super.show();
        this.helpDialog.mc_tabs.gotoAndStop(1);
        this.helpDialog.txt_title.text = Poker2Model.languageData.getTextById("help_title");
        this.activateButton(this.helpDialog.mc_tabs.tab1);
        this.changeTab(this.helpDialog.mc_tabs.tab1);

        this.helpDialog.bg.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.helpDialog.btn_close:
                this.hide();
                break;
            case this.helpDialog.mc_tabs.tab1:
            case this.helpDialog.mc_tabs.tab1_sub1:
            case this.helpDialog.mc_tabs.tab1_sub2:
            case this.helpDialog.mc_tabs.tab1_sub3:
            case this.helpDialog.mc_tabs.tab1_sub4:
            case this.helpDialog.mc_tabs.tab2:
            case this.helpDialog.mc_tabs.tab2_sub1:
            case this.helpDialog.mc_tabs.tab3:
                this.activateButton(event.target as BasicButton);
                this.changeTab(event.target as BasicButton);
                break;
            case this.helpDialog.btn_up:
                if (this.helpDialog.btn_up.enabled)
                    this.changePage(this.currentPage - 1);
                break;
            case this.helpDialog.btn_down:
                if (this.helpDialog.btn_down.enabled)
                    this.changePage(this.currentPage + 1);
                break;
        }
    }

    private changePage(page: number): void {
        this.currentPage = page;
        this.helpDialog.txt_copy.y = this.helpDialog.mc_copymask.y - (this.currentPage * (this.helpDialog.mc_copymask.height / 2));
        this.helpDialog.btn_down.enableButton = (this.helpDialog.txt_copy.textHeight - (this.helpDialog.mc_copymask.y - this.helpDialog.txt_copy.y)) > this.helpDialog.mc_copymask.height;
        this.helpDialog.btn_up.enableButton = this.currentPage > 0;
    }

    private activateButton(button: BasicButton): void {
        if (this.selectedButton != button) {
            if (this.selectedButton) this.selectedButton.deselected();
            this.selectedButton = button;
            this.selectedButton.selected();
        }
    }
    private changeTab(button: BasicButton): void {
        this.helpDialog.txt_tabtitle.text = Poker2Model.languageData.getTextById("help_" + button.name);
        this.helpDialog.txt_copy.mouseWheelEnabled = false;
        this.helpDialog.txt_copy.htmlText = Poker2Model.languageData.getTextById("help_" + button.name + "_content", [this.env.gameTitle]);
        this.helpDialog.txt_copy.height = this.helpDialog.txt_copy.textHeight + 5;
        this.helpDialog.txt_copy.y = this.helpDialog.mc_copymask.y;
        this.multiPage = this.helpDialog.txt_copy.height > this.helpDialog.mc_copymask.height;
        this.helpDialog.btn_down.visible = this.helpDialog.btn_up.visible = this.multiPage;
        this.changePage(0);

    }
    private setButtonText(): void {
        var nextTab: boolean = true;
        var tabIndex: number = 1;
        while (nextTab) {
            if ("tab" + tabIndex in this.helpDialog.mc_tabs && tabIndex <= Poker2HelpDialog.MAX_TABS_HELP) {
                this.helpDialog.mc_tabs["tab" + tabIndex].minWidth = 100;
                this.helpDialog.mc_tabs["tab" + tabIndex].textXOffset = 15;
                this.helpDialog.mc_tabs["tab" + tabIndex].label = Poker2Model.languageData.getTextById("help_tab" + tabIndex);
                var nextSubTab: boolean = true;
                var subTabIndex: number = 1;
                while (nextSubTab) {
                    if ("tab" + tabIndex + "_sub" + subTabIndex in this.helpDialog.mc_tabs) {
                        this.helpDialog.mc_tabs["tab" + tabIndex + "_sub" + subTabIndex].minWidth = 70;
                        this.helpDialog.mc_tabs["tab" + tabIndex + "_sub" + subTabIndex].textXOffset = 10;
                        this.helpDialog.mc_tabs["tab" + tabIndex + "_sub" + subTabIndex].label = Poker2Model.languageData.getTextById("help_tab" + tabIndex + "_sub" + subTabIndex);
                        subTabIndex++;
                    }
                    else
                        nextSubTab = false;
                }
                tabIndex++;
            }
            else
                nextTab = false;
        }
    }

    protected get helpDialog(): Library.PokerInterface.PokerHelp {
        return this.disp as Library.PokerInterface.PokerHelp;
    }
}
